import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Gold Tiara Headband (faire.com/product/p_z7fktr7rcu), via the
// authenticated PDP reviews API (verbatim reviewer name/location/text/date —
// nothing paraphrased or invented).
export const review_sw2: FaireReviewEntity = {
  token: "review_sw2",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_z7fktr7rcu",
  productImageUrl:
    "https://cdn.faire.com/fastly/4c0a1688dbce4f1654c7331dd8f0a9f01a4a132ccba55a80bb185eb4a6cc071f.jpeg",
  reviewerName: "Suzanne S.",
  reviewerLocation: "Cary, NC",
  stars: 5,
  reviewText:
    "This is one of our favorite brands we work with. They are so quick at responding and their products are amazing! We were surprised by the quality and keep all their stuff in stock for our customers!",
  reviewDate: "Mar 21, 2023",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-11T21:28:00.000Z",
    importedBy: "entity-db-cli",
  },
};
